import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { fetchAppointments } from '../../actions/appointments';
import viewHelper from '../../helpers/view';
import Spinner from '../shared/spinner';
import NoRecordFound from "../shared/noRecordFound";
import Filters from "../shared/filters";
import FilterService from "../../services/filterService";

let COMPONENT_TYPE = 'appointments';

class Appointments extends Component {

    constructor(props) {
        super(props);
        this.state = {
            filters: FilterService.getDefaultFilters(COMPONENT_TYPE)
        }
    }

    componentDidMount() {
        let params = FilterService.filtersToParams(this.state.filters);
        this.props.fetchAppointments(params);
    }

    renderAppointments() {
        let appointments = this.props.appointments;
        if(appointments.length > 0) {
            return _.map(appointments, (appointment) => {
                return (
                    <div className="media item" key={appointment.id}>
                        <div className="media-body">
                            <h4 className="media-heading">
                                {appointment.activity_name}
                                {appointment.trainer_name ? ` - ${appointment.trainer_name}` : ''}
                            </h4>
                            <div className="column">
                                <span className="label-heading">Date:</span>
                                <span className="label-text">{viewHelper.getFormattedDate(appointment.start_date)}</span>
                            </div>

                            <div className="column">
                                <span className="label-heading">Time:</span>
                                <span className="label-text">{viewHelper.getFormattedTime(appointment.start_time)} - {viewHelper.getFormattedTime(appointment.end_time)}</span>
                            </div>

                            <div className="column">
                                <span className="label-heading">Activity:</span>
                                <span className="label-text">{appointment.activity_name}</span>
                            </div>
                        </div>
                    </div>
                )
            });
        } else {
            return <NoRecordFound/>;
        }
    }

    setFilters(newFilters) {
        return this.setState({filters: newFilters}, () => {
            let params = FilterService.filtersToParams(this.state.filters);
            this.props.fetchAppointments(params);
        });
    }

    render () {
        const { appointments } = this.props;
        if(!appointments) {
            return (
                <div className="container content">
                    <Spinner />
                </div>
            );
        } else {
            return (
                <div className="col-xs-12 col-md-12 col-lg-12 no-padding">
                    <div className="row-eq-height border-top">
                        <div className="col-xs-12 col-md-3 col-lg-3 filters">
                            <Filters title='Filter Appointments' filters={this.state.filters} callbackToUpdateComponent={this.setFilters.bind(this)} />
                        </div>
                        <div className="col-xs-12 col-md-9 col-lg-10 no-padding border-bottom">
                            <ul className="detail-list">
                                {this.renderAppointments()}
                            </ul>
                        </div>
                    </div>
                </div>
            );
        }
    }
}
function mapStateToProps(state) {
    const { appointments } = state;
    return {
        appointments
    };
}

export default connect(mapStateToProps, { fetchAppointments })(Appointments);